import { render, staticRenderFns } from "./InstanceEditTenants.vue?vue&type=template&id=aa5829e8&scoped=true&"
import script from "./InstanceEditTenants.vue?vue&type=script&lang=js&"
export * from "./InstanceEditTenants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa5829e8",
  null
  
)

export default component.exports